import { render, staticRenderFns } from "./CashIncome.vue?vue&type=template&id=5b55dc56&scoped=true"
import script from "./CashIncome.vue?vue&type=script&lang=js"
export * from "./CashIncome.vue?vue&type=script&lang=js"
import style0 from "./CashIncome.vue?vue&type=style&index=0&id=5b55dc56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b55dc56",
  null
  
)

export default component.exports